<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('familyCategories.title') }}</h2>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'FamilyCategories',
  };
</script>
